<template>
  <YFooter
    brand="quero-bolsa"
  >
    <YFooter.Above has-full-visibility />
  </YFooter>
</template>

<script>
import { YFooter } from '@quero/yeti'

export default {
  name: 'TheFooter',
  components: {
    ...YFooter,
  },
}
</script>
